<aside class="outages-notice component" [ngStyle]="{ 'border-top-color': opCoColor }">
  <header class="col-md-7">
    <h2>{{ copyTitle }}</h2>
    <span class=caption>{{ copyCaption }}</span>
  </header>

  <div class=shelf>
    <app-button-common classType="text" (click)="onClickCTA()">
      <span class="cta copy">{{ copyCTA }}</span>
    </app-button-common>
  </div>
</aside>
